import React, { useEffect, useState } from 'react'
import { strings } from '../../../localization/strings'
import { makeStyles, MenuItem, Divider, Typography, Dialog, DialogTitle, DialogContent, IconButton, Checkbox, Collapse } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Alert from '@material-ui/lab/Alert';
import Loader from '../../loaders';

const useStyles = makeStyles((theme) => ({
    newsContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    news: {
        width: '850px',
        paddingBottom: '20px',
        [theme.breakpoints.down('xs')]: {
            width: '100vw',
        },
        '& tbody tr': {
            border: 'none !important',
        },
        '& table': {
            borderCollapse: 'collapse',
        },
    },
    newsHeader: {
        fontSize: '45px',
        fontWeight: '500',
        paddingLeft: '60px',
        paddingTop: '20px',
        paddingBottom: 0,
    },
    newsSubtitle: {
        color: '#f7b500',
        paddingLeft: '60px',
        fontSize: '25px',
        margin: '40px 0 15px',
    },
    noNews: {
        textAlign: 'center',
        fontStyle: 'italic',
    },
    menuItem: {
        borderBottom: '.5px solid #c2bfbf',
        padding: '10px',
        justifyContent: 'space-between',
        alignItems: 'start',
        flexWrap: 'wrap',
        cursor: 'default'
    },
    itemText: {
        width: '80%',
        minWidth: '270px',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere',
        flexGrow: 1,
    },
    newsTitle: {
        fontWeight: 'bold',
        fontSize: '20px',
    },
    newsContent: {
        paddingLeft: '50px',
    },
    newsDate: {
        paddingLeft: '50px',
        fontStyle: 'italic',
    },
    newsActionBtn: {
        width: '90px',
        textAlign: 'center',
        margin: '5px',
        borderRadius: '5px',
        border: '1px solid #f7b500',
        color: '#f7b500',
        '&:hover': {
            backgroundColor: '#f7b500',
            color: '#fff',
            cursor: 'pointer'
        },
    },
    closeBtn: {
        position: 'absolute',
        right: 0,
        top: 0,
        [theme.breakpoints.down('xs')]: {
            right: '35px',
            top: '5px',
        },
    },
    seeAll: {
        fontSize: '20px',
        marginTop: '10px',
        color: '#f7b500',
        justifyContent: 'right',
    },
    actions: {
        flexGrow: 1,
        width: '20%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '130px'
    },
    acceptContainer: {
        width: '100%',
    },
    accept: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px',
        '& p': {
            fontSize: '14px',
        },
    },
    alert: {
        padding: '6px',
        height: '25px',
        '& div': {
            padding: '0',
        },
    },
    checkbox: {
        color: '#f7b500',
        transform: 'scale(.6)',
        padding: '0',
        float: 'left',
    },
    divider: {
        height: 2,
        backgroundColor: '#f7b500',
    },
}))

const NewsPanel = (props) => {
    const { unreadNews, readNews, openPanel, closeNewsPanel, handleNewsRead } = props
    const styles = useStyles()

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
    const [loadingNew, setLoadingNew] = useState(null)
    const [newsPerPage, setNewsPerPage] = useState(5)
    const [checked, setChecked] = useState({});
    const [openAcceptAlert, setOpenAcceptAlert] = useState({})
    const [selectedNew, setSelectedNew] = useState(null)
    const newsToShow = readNews.slice(0, newsPerPage)

    useEffect(() => {
        if (openAcceptAlert) {
            const timer = setTimeout(() => {
                setOpenAcceptAlert('')
            }, 3000)
            return () => clearTimeout(timer)
        }
    }, [openAcceptAlert])

    const handleClose = () => {
        setNewsPerPage(5);
        closeNewsPanel();
    }

    const handleCheck = (e, newsId) => {
        setChecked(prevState => ({
            ...prevState,
            [newsId]: e.target.checked
        }))
    }

    const handleCollapse = (newId) => {
        setSelectedNew(newId === selectedNew ? null : newId)
    }

    const handleClick = (oneNew) => {
        setLoadingNew(oneNew.id)
        setTimeout(() => {
            if (oneNew.type === 4 && !checked[oneNew.id]) {
                setOpenAcceptAlert(oneNew.id)
            } else {
                handleNewsRead(oneNew, checked, oneNew.id)
            }
            setLoadingNew(null)
        }, 0)
    }

    const validDate = (date) => date.slice(0, 10).split('-').reverse().join('/');

    return (
        <Dialog
            className={styles.newsContainer}
            open={openPanel}
            onClose={handleClose}
            maxWidth={'md'}
            fullWidth
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            scroll={'paper'}
            fullScreen={fullScreen}
        >
            <DialogTitle id="scroll-dialog-title" className={styles.newsHeader} disableTypography>
                {strings.newsPanel.newsTitle}
                <IconButton
                    aria-label="close"
                    className={styles.closeBtn}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers={false}>
                <div id="scroll-dialog-description" className={styles.news}>
                    <p className={styles.newsSubtitle}> {strings.newsPanel.newNews} </p>
                    <Divider className={styles.divider} />
                    {unreadNews && unreadNews.length ?
                        (unreadNews.map((oneNew) => {
                            return <MenuItem className={styles.menuItem} key={oneNew.id} disableRipple>
                                <div className={styles.itemText}>
                                    <Typography className={styles.newsTitle}>
                                        <IconButton
                                            onClick={() => handleCollapse(oneNew.id)}
                                            color='secondary'
                                        >
                                            <ExpandMoreIcon />
                                        </IconButton>
                                        {oneNew.title}
                                    </Typography>
                                    <Collapse in={selectedNew === oneNew.id}>
                                        <div id='newText' dangerouslySetInnerHTML={{ __html: oneNew.text }} className={styles.newsContent}>
                                        </div>
                                        <p className={styles.newsDate}>{strings.newsPanel.newFromDate}{validDate(oneNew.fromDate)}</p>
                                        {oneNew.toDate ?
                                            <p className={styles.newsDate}>{strings.newsPanel.newToDate}{validDate(oneNew.toDate)}</p>
                                            : null}
                                    </Collapse>
                                </div>
                                {loadingNew ? <Loader /> :
                                    <div className={styles.actions}>
                                        <span className={styles.newsActionBtn} onClick={() => { handleClick(oneNew) }}>
                                            {oneNew.type === 4 ? strings.newsPanel.acceptType : strings.newsPanel.readType}
                                        </span>
                                        {oneNew.type === 4 ?
                                            <div className={styles.acceptContainer}>
                                                <div className={styles.accept}>
                                                    <Checkbox
                                                        checked={checked[oneNew.id] || false}
                                                        onChange={(e) => handleCheck(e, oneNew.id)}
                                                        className={styles.checkbox}
                                                        color='default'
                                                    />
                                                    <Typography> {strings.newsPanel.confirm} </Typography>
                                                </div>
                                                <Collapse in={!checked[oneNew.id] && openAcceptAlert === oneNew.id}>
                                                    <Alert
                                                        severity="error"
                                                        className={styles.alert}
                                                    >
                                                        {strings.newsPanel.mustConfirm}
                                                    </Alert>
                                                </Collapse>
                                            </div>
                                            : null
                                        }
                                    </div>
                                }
                            </MenuItem>
                        }))
                        : (<p className={styles.noNews}> {strings.newsPanel.noUnreadNews} </p>)}
                    <p className={styles.newsSubtitle}> {strings.newsPanel.read} </p>
                    <Divider className={styles.divider} />
                    {readNews ?
                        (newsToShow.map((oneNew) => {
                            return <MenuItem className={styles.menuItem} key={oneNew.id} disableRipple>
                                <div className={styles.itemText}>
                                    <Typography className={styles.newsTitle}>
                                        <IconButton
                                            onClick={() => handleCollapse(oneNew.id)}
                                            color='secondary'
                                        >
                                            <ExpandMoreIcon />
                                        </IconButton>
                                        {oneNew.title}
                                    </Typography>
                                    <Collapse in={selectedNew === oneNew.id}>
                                        <div id='newText' dangerouslySetInnerHTML={{ __html: oneNew.text }} className={styles.newsContent}>
                                        </div>
                                        <p className={styles.newsDate}>{strings.newsPanel.newFromDate}{validDate(oneNew.fromDate)}</p>
                                        {oneNew.toDate ?
                                            <p className={styles.newsDate}>{strings.newsPanel.newToDate}{validDate(oneNew.toDate)}</p>
                                            : null}
                                    </Collapse>
                                </div>
                            </MenuItem>
                        }))
                        : (<p className={styles.noNews}> {strings.newsPanel.noReadNews} </p>)}
                    {readNews && readNews.length > newsToShow.length ?
                        <MenuItem
                            className={styles.seeAll}
                            onClick={() => setNewsPerPage(newsPerPage + 5)}
                        >
                            {strings.newsPanel.more}
                        </MenuItem>
                        : null}
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default NewsPanel
